    /**
     * Custom Select
     */
    function customSelect($originSelect) {
        jQuery(function($) {
            $originSelect.each(function(){
                var $this = $(this), numberOfOptions = $(this).children('option').length;
            
                $this.addClass('select-hidden'); 
                $this.wrap('<div class="select"></div>');
                $this.after('<div class="select-styled default"></div>');
            
                var $styledSelect = $this.next('div.select-styled');
                let currentOption = $this.children('option:selected');
                if ( currentOption.val() ) {
                    $styledSelect.text( $this.children('option').eq(currentOption.index()).text());
                } else {
                    let $defaultOption =  $this.children('option').eq(0);
                    $styledSelect.html( '<span class="default">' + $defaultOption.text() + '</span>');
                    if (!$defaultOption.val()) {
                        $this.trigger('select-empty-value');
                        //$('#place_order').prop('disabled', true);
                    }
                }

                var $list = $('<ul />', {
                    'class': 'select-options'
                }).insertAfter($styledSelect);
            
                for (var i = 0; i < numberOfOptions; i++) {
                    if ( $this.children('option').eq(i).val() ) {
                        $('<li />', {
                            class: currentOption.val() === $this.children('option').eq(i).val() ? 'active' : '',
                            text: $this.children('option').eq(i).text(),
                            rel: $this.children('option').eq(i).val()
                        }).appendTo($list);
                    }
                }
            
                var $listItems = $list.children('li');
            
                $styledSelect.click(function(e) {
                    $(this).removeClass('default');
                    e.stopPropagation();
                    $('div.select-styled.active').not(this).each(function(){
                        $(this).removeClass('active').next('ul.select-options').hide();
                    });
                    $(this).toggleClass('active').next('ul.select-options').toggle();
                });
            
                $listItems.click(function(e) {
                    e.stopPropagation();
                    const $currentItem = $(this)
                    const $siblingItems = $currentItem.siblings()

                    $currentItem.addClass('active')
                    $siblingItems.removeClass('active')

                    $styledSelect.text($currentItem.text()).removeClass('active');
                    $this.val($(this).attr('rel'));
                    $list.hide();
                    $($this).trigger('change');
                });
            
                $(document).click(function() {
                    $styledSelect.removeClass('active');
                    $list.hide();
                });
            });
        });
    }

    export default customSelect;